/** Finance secondary nav (One host short paths). */

export type FinanceNavLink = {
  name: string;
  href: string;
  comingSoon?: boolean;
};

export const financeSalesChildLinks: FinanceNavLink[] = [
  { name: "Accounts", href: "/finance/sales/accounts" },
  { name: "Quotes", href: "/finance/sales/quotes", comingSoon: true },
  { name: "Invoices", href: "/finance/sales/invoices" },
  { name: "Recurring invoices", href: "/finance/sales/recurring-invoices", comingSoon: true },
  { name: "Retainer invoices", href: "/finance/sales/retainer-invoices", comingSoon: true },
  { name: "Sales orders", href: "/finance/sales/sales-orders", comingSoon: true },
  { name: "Payments received", href: "/finance/sales/payments-received" },
  { name: "Credit notes", href: "/finance/sales/credit-notes", comingSoon: true },
];

export const financePurchasesChildLinks: FinanceNavLink[] = [
  { name: "Vendors", href: "/finance/purchases/vendors" },
  { name: "Bills", href: "/finance/purchases/bills", comingSoon: true },
  { name: "Recurring bills", href: "/finance/purchases/recurring-bills", comingSoon: true },
  { name: "Payments made", href: "/finance/purchases/payments-made", comingSoon: true },
  { name: "Vendor credits", href: "/finance/purchases/vendor-credits", comingSoon: true },
];
